export default __webpack_public_path__ + "static/media/unscLogo.52128abf.png";